// Import Slick
import 'slick-carousel';


// WEBPACK FOOTER //
// ./scripts/autoload/_slick-carousel.js